import { createDomain } from 'effector'
import { ReactNode } from 'react'

const domain = createDomain('notificationModal')

type NotificationModalType =
  | {
      variant: 'success' | 'error' | 'warning'
      buttonTitle?: string
      onClose?: () => Promise<void> | void
    } & ({ title: string } | { description: string } | { content: ReactNode })

export const notificationModalOpen = domain.createEvent<NotificationModalType>()
export const notificationModalClose = domain.createEvent()
export const $notificationModal = domain
  .createStore<NotificationModalType | null>(null)
  .on(notificationModalOpen, (_, config) => config)
  .on(notificationModalClose, () => null)
